export default "__VITE_ASSET__Fc4qswOT__"